module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAIAAAC0D9CtAAAABnRSTlMAAAAAAABupgeRAAAAOElEQVR4nGNgGDng////WMWZSNWAUw8eDdj14NeARQ9BDVj0MDIykqyHGG3Yw4AY27ADYvw2HAAA6EISBqg5edUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/icon-left-white.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/icon-left-white.png
// module chunks = styles